<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Invoices",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Invoices",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Invoices",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 10,
      IsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      delete: {
        id: "",
        customer: "",
      },
      filterInvoices: {
        customer_id: "",
        product_id: "",
        invoice_number: "",
        receipt_number: "",
        datefrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 10,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("invoices", [
      "Invoices",
      "SaveStatus",
      "filterStatus",
      "InvoicesPagination",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("sales", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.IsServerPaginated
        ? this.InvoicesPagination.total
        : this.Invoices
        ? this.Invoices.length
        : 0;
    },

    currentPage: {
      get() {
        return this.IsServerPaginated
          ? this.InvoicesPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsServerPaginated
          ? this.InvoicesPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.serverPerPage = value;
          this.filterInvoices.per_page = value;
          this.filterInvoices.page = 1;
          this.FilterInvoices();
        } else {
          this.clientPerPage = value;
        }
      },
    },

    /**
     * Todo list of records
     */
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchInvoices: "invoices/fetchInvoices",
      Delete: "invoices/deleteInvoice",
      FetchCustomers: "customers/fetchCustomers",
      FetchItems: "sales/fetchItems",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    redirect(value) {
      this.$router.push(`/invoice_details/${btoa(value)}`);
    },

    SetdeleteData(data) {
      (this.delete.id = data.id), (this.delete.customer = data.customer);
    },

    DeleteInvoice(modalId) {
      this.Delete(this.delete);
      this.closeModal(modalId);
    },

    resetDelete() {
      (this.delete.id = ""), (this.delete.customer = "");
    },

    closeModal(modalId) {
      this.resetDelete();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    handlePageChange(newPage) {
      if (this.IsServerPaginated) {
        let payload = {
          ...this.filterInvoices,
          page: newPage,
          per_page: this.serverPerPage,
        };
        this.filterInvoices.page = newPage;
        this.FetchInvoices(payload);
      }
    },

    FilterInvoices() {
      this.filterInvoices.page = 1;
      this.filterInvoices.per_page = this.serverPerPage;
      this.FetchInvoices(this.filterInvoices);
    },

    ClearFilters() {
      this.filterInvoices = {
        customer_id: "",
        product_id: "",
        invoice_number: "",
        receipt_number: "",
        datefrom: "",
        dateto: "",
        page: 1,
        per_page: this.serverPerPage,
      };
      this.FilterInvoices();
    },
  },
  created() {
    this.FetchCustomers();
    this.FetchItems();
    this.FilterInvoices();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Generated Invoices</h4>
              </div>
            </div>

            <!-- Filters Section -->
            <div class="row mt-4 mb-4">
              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY CUSTOMER</label>
                <model-list-select
                  :list="
                    Customers
                      ? [{ id: '', name: 'All Customers' }, ...Customers]
                      : []
                  "
                  v-model="filterInvoices.customer_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Customer"
                  @input="FilterInvoices()"
                >
                </model-list-select>
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY PRODUCT</label>
                <model-list-select
                  :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                  v-model="filterInvoices.product_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="FilterInvoices()"
                >
                </model-list-select>
              </div>

               <div class="col-sm-3 col-md-3 form-group">
                <label>INVOICE NUMBER</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filterInvoices.invoice_number"
                  placeholder="Enter invoice number"
                  @keyup.enter="FilterInvoices()"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>RECEIPT NUMBER</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filterInvoices.receipt_number"
                  placeholder="Enter receipt number"
                  @keyup.enter="FilterInvoices()"
                />
              </div>
            </div>

            <!-- Date Range Filter Row -->
            <div class="row mb-4">
              <div class="col-sm-3 col-md-3 form-group">
                <label>FROM DATE</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filterInvoices.datefrom"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>TO DATE</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filterInvoices.dateto"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group d-flex align-items-end">
                <button class="btn btn-primary me-2" @click="FilterInvoices">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
                <b-button variant="secondary" @click="ClearFilters()">
                  <i class="fa fa-refresh"></i> Clear
                </b-button>
              </div>
            </div>

               <div class="row mt-4">
                  <div class="col-sm-12 col-md-4">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <div class="col-md-4"></div>
                
                </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-3 ">
              <table
                class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
              >
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>DATE</th>
                    <th>CUSTOMER</th>
                    <th>PRODUCTS</th>
                    <th>TOTAL</th>
                    <th>PAID</th>
                    <th>BALANCE</th>
                    <th>INVOICE NUMBER</th>
                    <th>RECEIPT NUMBER</th>
                    <th>RECORDED ON</th>
                    <th>USER</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>

                <tbody v-if="!filterStatus && Invoices && Invoices.length > 0">
                  <tr v-for="(item, index) in Invoices" :key="item.id">
                    <td>{{ InvoicesPagination.from + index }}</td>
                    <td>{{ item.date }}</td>
                    <td>
                      {{ item.customer?item.customer.name:'' }} - {{ item.customer?item.customer.contact:'' }}
                    </td>
                    <td>{{ item.items.length }}</td>
                    <td>{{ thousandSeperator(item.total) }}</td>
                    <td>{{ thousandSeperator(item.paid) }}</td>
                    <td>{{ thousandSeperator(item.total - item.paid) }}</td>
                    <td>{{ item.invoice_number }}</td>
                    <td>{{ item.receipt_number }}</td>
                    <td>{{ item.addedon }}</td>
                    <td>{{ item.user }}</td>
                    <td>
                      <b-button-group>
                        <b-button
                          v-if="MyUserPerm.view_invoices == 1"
                          size="sm"
                          variant="primary"
                          @click="redirect(item.id)"
                          ><i class="fa fa-eye"></i> View</b-button
                        >
                        <b-button
                          v-if="MyUserPerm.delete_invoices == 1"
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-modal
                          @click="SetdeleteData(item)"
                          ><i class="fa fa-trash"></i> Delete</b-button
                        >
                      </b-button-group>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="filterStatus">
                  <tr>
                    <td :colspan="12" class="text-center">
                      <div class="row">
                          <div class="skeleton-row" v-for="i in 5" :key="i"></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="!filterStatus && (!Invoices || Invoices.length === 0)"
                >
                  <tr>
                    <td :colspan="12" class="text-center">
                      No Invoices found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- Delete Model -->
            <b-modal id="delete-modal" hide-footer @hidden="resetDelete()">
              <template #modal-title>
                <h4 class="text-danger">
                  Your are deleting this Invoice
                </h4></template
              >

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="DeleteInvoice('delete-modal')"
                >
                  <i class="fa fa-trash"></i> Delete
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
th {
  vertical-align: top;
  white-space: normal;
}
</style>
